
	<template>
  <div class="search-container">
    <input
      v-model="keyword"
      type="text"
      placeholder="Search keyword..."
    />
    <button @click="search">Search</button>

  <div v-for="(r, i) in results" :key="i" class="matched-table">
  <div class="table-meta">
    <strong>{{ r.file }}</strong> - <span class="tag">{{ r.type }}</span> 
    (Page {{ r.page }})
  </div>
  <table>
    <thead>
      <tr>
        <th v-for="(h, j) in r.table_header" :key="j">{{ h }}</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td v-for="(cell, j) in r.matched_row" :key="j" style="white-space: pre-line;">
          {{ cell }}
        </td>
      </tr>
    </tbody>
  </table>
</div>


    <p v-if="searched && !results.length">No results found.</p>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "FileSearch",
  data() {
    return {
      keyword: "",
      results: [],
      searched: false,
    };
  },
  methods: {
    search() {
      if (!this.keyword) {
        alert("Please enter a search keyword");
        return;
      }

      axios
        .post("/mproduct/indexsearch", {
          keyword: this.keyword,
        })
        .then((response) => {
          console.log(response.data);
          this.results = response.data;
          this.searched = true;
        })
        .catch((error) => {
          console.error(error);
          alert("Search failed");
        });
    },
  },
};
</script>


<style scoped>
.search-container {
  padding: 20px;
}

input {
  padding: 6px;
  width: 300px;
  margin-right: 10px;
}

button {
  padding: 6px 12px;
  cursor: pointer;
}

.matched-table {
  margin-bottom: 30px;
}

.matched-table table {
  width: 100%;
  border-collapse: collapse;
}

.matched-table th,
.matched-table td {
  border: 1px solid #ddd;
  padding: 6px;
  text-align: left;
}

.matched-table th {
  background-color: #f5f5f5;
}
</style>
